import React from 'react';
import {validateEmail, hideAlertAfterDelay} from "../../helper";
import API from "../../api";
import {withSnackbar} from "notistack";
import {Modal} from "react-bootstrap";
import {images} from "../../constant";
import "../../assets/css/notification.css";

const api = new API();

class Subscribe extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            email: "",
            show: false,
            error: false,
            errors : {},
            errorAlert: null,
            emailTouched: false,
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    getEmailValidationError(email) {
        return !email || !validateEmail(email) ? "Enter valid email address" : "";
    }

    getEmailErrors(emailError) {
        return emailError ? {email: emailError} : {};
    }

    showTimedErrorAlert(message) {
        this.setState({
            errors: {},
            errorAlert: message,
        });

        if (this.alertTimeout) {
            clearTimeout(this.alertTimeout);
        }

        this.alertTimeout = hideAlertAfterDelay(() => {
            this.setState({ errorAlert: null });
        });
    }

    handleChange(event) {
        const email = event.target.value;
        // Keep initial typing quiet; after blur/submit, validate on change so visible errors clear immediately.
        const emailError = this.state.emailTouched ? this.getEmailValidationError(email) : "";

        this.setState({
            email,
            errorAlert: null,
            errors: this.getEmailErrors(emailError),
        });
    }

    handleBlur() {
        const emailError = this.getEmailValidationError(this.state.email);

        this.setState({
            emailTouched: true,
            errors: this.getEmailErrors(emailError),
        });
    }

    handleSubmit(event) {
        this.setState({errorAlert: null});
        event.preventDefault();

        const emailError = this.getEmailValidationError(this.state.email);

        if (emailError) {
            this.setState({
                emailTouched: true,
                errors: this.getEmailErrors(emailError),
            });
            return false;
        }

        api.subscription({email: this.state.email}).then(success => {
            if (success.data.status == "400") {
                this.showTimedErrorAlert(success.data.message);
            } else {
                this.setState({
                    show: true,
                    email: "",
                    errors: {},
                    emailTouched: false,
                });
            }
        }).catch(error => {
            this.setState({
                error: false,
                email: "",
                emailTouched: false,
            });
            this.showTimedErrorAlert(error?.response?.data?.message || "Something went wrong. Please try again.");
        });
    }

    render() {
        return (
            <React.Fragment>

                <div
                    className="subscribe-info"
                    data-aos="zoom-in"
                    data-aos-easing="linear"
                >
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-md-12 col-lg-12 col-xl-12 p-0">
                                <div className="col-12 subscribe-details">
                                    <div className="row">
                                        <div className="col-md-5">
                                            <h4>SUBSCRIBE AND SAVE</h4>
                                            <p>Join today for special offers and deals!</p>
                                        </div>
                                        <form className="col-md-7 action">
                                            <div className='row w-100'>
                                                <div className='col-md-12'>
                                                    {this.state.errorAlert ? (
                                                        <div role="alert" class="sc-1wz9i2x-0 fooVeK">
                                                            <svg
                                                                width="1792"
                                                                height="1792"
                                                                viewBox="0 0 1792 1792"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                aria-hidden="true"
                                                                class="sc-1t1e23j-0 bbiirI"
                                                            >
                                                            <path
                                                                fill="currentColor"
                                                                d="M1024 1375v-190q0-14-9.5-23.5T992 1152H800q-13 0-22.5 9.5T768 1185v190q0 14 9.5 23.5t22.5 9.5h192q13 0 22.5-9.5t9.5-23.5zm-2-374l18-459q0-12-10-19-13-11-24-11H786q-11 0-24 11-10 7-10 21l17 457q0 10 10 16.5t24 6.5h185q14 0 23.5-6.5t10.5-16.5zm-14-934l768 1408q35 63-2 126-17 29-46.5 46t-63.5 17H128q-34 0-63.5-17T18 1601q-37-63-2-126L784 67q17-31 47-49t65-18 65 18 47 49z"
                                                            ></path>
                                                            </svg>
                                                            <span>{this.state.errorAlert}</span>
                                                        </div>
                                                    ) : null}
                                                </div>
                                                <div className='col-md-12'>
                                                    <div className="form-group">
                                                        <input
                                                            type="text"
                                                            name="email"
                                                            placeholder="Enter email"
                                                            value={this.state.email}
                                                            className={
                                                                "form-control valid-control " +
                                                                (this.state.errors.email ? "invalid" : "")
                                                            }
                                                            onChange={this.handleChange}
                                                            onBlur={this.handleBlur}
                                                        />
                                                        <span className="error-text mt-1 mb-1">
                                                            {this.state.errors.email}
                                                        </span>
                                                    </div>
                                                    <button className="btn btn-m btn-order" onClick={this.handleSubmit}>
                                                        Subscribe now
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 p-0">
                                <hr className="bg-white my-4"/>
                            </div>
                        </div>
                    </div>
                </div>

                <Modal
                    dialogClassName="modal-dialog-centered"
                    onHide={() => {
                        this.setState({
                            show: false
                        })
                    }}
                    show={this.state.show}
                    // show={true}
                    className="storeModal">
                    <Modal.Body>
                        <div className="modal-body">
                            <div className="col-12 text-center p-0">
                                    <span className="">
                                          <img width="100px"
                                               src={images.successStar}
                                          />
                                    </span>
                                <h3 className="card-head w-100 mt-3 mb-2">Thank you for subscription!</h3>
                                <h6 className="card-text w-100 mt-2 mb-3">You have successfully subscribed to Farmer's Fresh Meat. Enjoy offers and updates in your email!</h6>
                            </div>
                            <div className="text-center">
                                <button onClick={() => {
                                    this.setState({show: false})
                                }}
                                        className="btn btn-s cart-button mb-3 mb-md-0"
                                        style={{
                                            transition: 'all .3s ease-in-out'
                                        }}>Done
                                </button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>


                <Modal
                    dialogClassName="modal-dialog-centered"
                    onHide={() => {
                        this.setState({
                            error: false
                        })
                    }}
                    show={this.state.error}
                    // show={true}
                    className="storeModal">
                    <Modal.Body>
                        <div className="modal-body">
                            <div className="col-12 text-center p-0">
                                    <span className="">
                                          <img width="100px"
                                               src={images.successStar}
                                          />
                                    </span>
                                <h3 className="card-head w-100 mt-3 mb-2">Already Subscribed!</h3>
                                <h6 className="card-text w-100 mt-2 mb-3">You are already in our subscriber's list. Enjoy offers and updates in your email!</h6>
                            </div>
                            <div className="text-center">
                                <button onClick={() => {
                                    this.setState({error: false})
                                }}
                                        className="btn btn-s cart-button mb-3 mb-md-0"
                                        style={{
                                            transition: 'all .3s ease-in-out'
                                        }}>Done
                                </button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </React.Fragment>
        );
    }
}

export default withSnackbar(Subscribe)
